import { Question, type Answer } from 'pages/Questionnaire/types';
import { createContext, FC, useCallback, useState } from 'react';

export const defaultContext = {
    answers: {},
    onAnswerChange: (_question: Question, _answer: Answer) => {
        return;
    }
};

type QuestionnaireContextType = {
    /**
     * Answers holds all the users answers in form of a object where key is question shortQuestionName
     * and value is {question: string, answer: string}.
     * {shortQuestionName: {question: string, answer: string}}
     */
    answers: {
        [key: string]: { question: string; answer: Answer };
    };
    /**
     * onAnswerChange accepts Question, answer it creates and sets a shortquestion to answer map.
     */
    onAnswerChange: (question: Question, answer: Answer) => void;
};

export const QuestionnaireContext = createContext<QuestionnaireContextType>(defaultContext);

export const QuestionnaireContextProvider: FC = ({ children }) => {
    const [answers, setAnswers] = useState<{ [key: string]: { question: string; answer: Answer } }>(defaultContext.answers);

    const onAnswerChange = useCallback(
        (question: Question, answer: Answer) => {
            setAnswers(answers => ({
                ...answers,
                [question.shortQuestionName]: { question: question.question, answer: answer }
            }));
        },
        [setAnswers]
    );

    return <QuestionnaireContext.Provider value={{ answers, onAnswerChange }}>{children}</QuestionnaireContext.Provider>;
};
